import { locationSurchargeType } from "./location-surcharge-type.const";
import { LocationSurchargeBase } from "./location-surcharge-base.model";
import { LocationSurcharge } from "./location-surcharge.type";
import { LocationSurchargeMapper } from "./location-surcharge.mapper";
import { Carrier } from "../../carrier/carrier.model";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { FclQuoteLocationSurcharge } from "../../quote/quote-surcharge/models/quote-location-surcharge-fcl.model";
import { SurchargeType } from "app/surcharge-type/surcharge-type.model";
import { SurchargeTypeMapper } from "app/surcharge-type/surcharge-type.mapper";

export class FclLocationSurcharge extends LocationSurchargeBase {
  constructor(
    public id: number,
    public discriminator: string,
    public name: string = "",
    protected carrier: Carrier,
    protected type: string = locationSurchargeType.destination,
    protected containers: ContainerPrices,
    protected shipmentPrice: number = 0,
    protected assignment: string = "",
    protected quoteLocationSurcharges?: FclQuoteLocationSurcharge[],
    public currency: string = "USD",
    public surchargeType?: SurchargeType,
    public debugInfo?: string,
    public chargedFor?: string,
    public internalNote?: string,
    public restrictedNote?: string,
    public availableOnline?: boolean,
    public sort?: number,
  ) {
    super(
      id,
      discriminator,
      name,
      carrier,
      type,
      assignment,
      quoteLocationSurcharges,
      currency,
      surchargeType,
      debugInfo,
      chargedFor,
      internalNote,
      sort,
    );
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public getShipmentPrice(): number {
    return +this.shipmentPrice;
  }
  public setShipmentPrice(param: number) {
    this.shipmentPrice = param;
  }

  public getFirstQuoteLocationSurcharge(): FclQuoteLocationSurcharge {
    if (this.haveQuoteLocationSurcharges()) {
      return this.quoteLocationSurcharges[0];
    }
  }

  public get shipmentDisplayUnitName(): string {
    return this.getFirstQuoteLocationSurcharge()?.shipmentDisplayUnitName;
  }

  public set shipmentDisplayUnitName(value: string) {
    this.getFirstQuoteLocationSurcharge().shipmentDisplayUnitName = value;
  }

  public getRequestParams() {
    return {
      containers: this.getContainers().getRequestParams(),
      shipmentPrice: this.getShipmentPrice(),
      carrier: this.getCarrier() ? this.getCarrier().getId() : null,
      name: this.getName(),
      type: this.getType(),
      availableOnline: this.availableOnline,
      sort: this.sort,
      surchargeType: this.getSurchargeType()
        ? this.getSurchargeType().getId()
        : null,
    };
  }

  public getClone(): LocationSurcharge {
    return LocationSurchargeMapper.map({
      id: this.id,
      discriminator: this.discriminator,
      name: this.name,
      carrier: this.carrier,
      type: this.type,
      containers: this.getContainers().getRequestParams(),
      shipmentPrice: this.getShipmentPrice(),
      assignment: this.assignment,
      quoteLocationSurcharges: this.quoteLocationSurcharges,
      currency: this.currency,
      availableOnline: this.availableOnline,
      sort: this.sort,
      chargedFor: this.chargedFor,
      debugInfo: this.debugInfo,
      surchargeType: SurchargeTypeMapper.map(this.getSurchargeType()),
    });
  }
}
